import { colorsTuple, MantineColorsTuple } from '@mantine/core';

export const blue: MantineColorsTuple = [
  '#ECF7FE',
  '#CFEDFC',
  '#1A9EE0',
  '#1A9EE0',
  '#1083CB',
  '#1083CB',
  '#1083CB',
  '#0E6DAD',
  '#354D67',
  '#354D67'
];

export const brightPink: MantineColorsTuple = [
  '#F0BBDD',
  '#ED9BCF',
  '#EC7CC3',
  '#ED5DB8',
  '#F13EAF',
  '#F71FA7',
  '#FF00A1',
  '#E00890',
  '#C50E82',
  '#AD1374'
];

export const neutral: MantineColorsTuple = [
  '#FFFFFF',
  '#EFF2F6',
  '#E0E5EB',
  '#B8C0CE',
  '#6C7789',
  '#6C7789',
  '#455468',
  '#455468',
  '#213147',
  '#213147'
];

export const plum: MantineColorsTuple = [
  '#EFF2F6',
  '#FDFAEE',
  '#EFE8DE',
  '#C9BBBE',
  '#A27E8A',
  '#7C5A61',
  // '#674759',
  '#4C0F28',
  '#572B3E',
  '#2C0817',
  '#4C0F28'
];

// Add more color definitions here

const colors = {
  blue,
  brightPink,
  neutral,
  plum,
  carrot: colorsTuple('#ffa200'),
  green: colorsTuple('#4fcc88'),
  red: colorsTuple('#ec1824'),
  sky: colorsTuple('#51c8ff')
  // Add other colors as needed
};

export default colors;
